<template lang="pug">
#filtrar-monitoramento-agricola
    .filtrar-monitoramento-agricola-container
        .filtrar-monitoramento-agricola-input-container
            .filtrar-monitoramento-agricola__input
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    :placeholder='$t("mensagens.blocoFiltros.uteis.placeholder")',
                    autocomplete='off',
                    @keyup.enter='pesquisar',
                    @blur='fecharLista'
                )

            .filtrar-monitoramento-agricola__resultado
                transition(name='el-zoom-in-top')
                    ul.filtrar-monitoramento-agricola__ul(
                        v-show='mostrarResultado'
                    )
                        .mb-2(v-for='resultadoPesquisa in resultadosPesquisa')
                            span.filtrar-monitoramento-agricola__categoria(
                                v-if='resultadoPesquisa.resultado.length'
                            ) {{ resultadoPesquisa.categoria }}

                            li(
                                v-for='resultado in resultadoPesquisa.resultado',
                                @click='selecionarResultado(resultado)'
                            )
                                span {{ resultado.valor }}

        .filtrar-monitoramento-agricola__button
            el-popover(placement='bottom', width='500', trigger='click')
                el-button.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}

                el-form.filtro(label-position='top')
                    .filtrar-monitoramento-agricola-popover-header
                        .filtrar-monitoramento-agricola-popover-header__text {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}
                        .filtrar-monitoramento-agricola-popover-header__link(
                            @click='aplicar'
                        )
                            | {{ $t('mensagens.blocoFiltros.uteis.aplicarFiltros') }}

                    .filtrar-monitoramento-agricola-popover-collapse
                        el-form-item.mb-0.filtro-accordion
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(
                                    title='Possui alertas',
                                    name='possuiAlertas'
                                )
                                    .el-collapse-item__possui-alertas
                                        el-radio(
                                            v-model='possuiAlertas',
                                            label='POSSUI'
                                        ) {{ $t('mensagens.blocoAlerta.possuiAlertas') }}
                                        el-radio(
                                            v-model='possuiAlertas',
                                            label='NAO_POSSUI'
                                        ) {{ $t('mensagens.blocoAlerta.naoPossuiAlertas') }}

                                el-collapse-item(title='Safras', name='safras')
                                    .el-collapse-item__safras--loading(
                                        v-loading='!safras.length'
                                    )
                                        el-checkbox-group(
                                            v-model='safrasSelecionadas'
                                        )
                                            el-checkbox(
                                                v-for='(safra, index) in safras',
                                                :label='safra',
                                                :key='index'
                                            ) {{ safra.valor }}

                                el-collapse-item(
                                    title='UF/Município',
                                    name='estados'
                                )
                                    .filtrar-monitoramento-agricola-popover-collapse__select(
                                        v-loading='!estados.length'
                                    )
                                        div
                                            el-select(
                                                v-model='estadoSelecionado',
                                                filterable,
                                                value-key='id',
                                                @change='buscarMunicipios()',
                                                placeholder='UF'
                                            )
                                                el-option(
                                                    v-for='(estado, index) in estados',
                                                    :key='index',
                                                    :label='estado.nome',
                                                    :value='estado'
                                                ) {{ estado.nome }}
                                        div
                                            el-select(
                                                v-model='municipioSelecionado',
                                                filterable,
                                                value-key='id',
                                                placeholder='Município'
                                            )
                                                el-option(
                                                    v-for='(municipio, index) in municipios',
                                                    :key='index',
                                                    :label='municipio.nome',
                                                    :value='municipio'
                                                ) {{ municipio.nome }}

    .filtrar-monitoramento-agricola-filtro-selecionado
        span.filtrar-monitoramento-agricola-filtro-selecionado__titulo {{ $t('mensagens.blocoFiltros.uteis.filtrosSelecionados') }}
        el-tag.filtrar-monitoramento-agricola-filtro-selecionado__tag(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ tag.nome || tag.valor }}

        span.filtrar-monitoramento-agricola-filtro-selecionado__nenhum(
            v-if='!tags.length'
        ) {{ $t('mensagens.blocoFiltros.uteis.nenhumFiltroSelecionado') }}
</template>

<script>
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import LocalidadeService from '@/services/LocalidadeService';
import { mapGetters } from 'vuex';

export default {
    name: 'FiltrarMonitoramentoAgricola',

    /**
     * Retorno
     *
     * atualizar-filtro-avancado:
     * {
     *   idSafras: [],
     *   possuiAlertas: String -> 'POSUI' || 'NAO_POSSUI'
     *   idRepresentantes: [],
     *   idTerritorios: [],
     *   idEstado: Number,
     *   idMunicipio: Number
     * }
     *
     */
    emits: ['atualizar-filtro-avancado', 'remover-cultura-selecionada'],
    props: {
        cultura: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            pesquisa: '',
            tags: [],
            collapseFiltroAvancado: [''],
            safras: [],
            safrasSelecionadas: [],
            possuiAlertas: '',
            estados: [],
            estadoSelecionado: {},
            municipios: [],
            municipioSelecionado: {},
            resultadosPesquisa: [],
            resultadosSelecionados: [],
            mostrarResultado: false,
            acaoCollapse: {
                safras: {
                    collapse: 'safras',
                    callback: 'buscarSafras'
                },
                estados: {
                    collapse: 'estados',
                    callback: 'buscarEstados'
                }
            },
            culturas: []
        };
    },
    watch: {
        cultura: function () {
            for (let tag of this.culturas) {
                if (tag && tag.codigo === 'CULTURA') {
                    this.culturas = [];
                }
            }
            if (this.cultura !== '') {
                this.culturas.push({
                    valor: this.cultura,
                    codigo: 'CULTURA'
                });
            }
            for (let tag of this.tags) {
                if (tag && tag.codigo === 'CULTURA') {
                    this.tags = this.tags.filter(
                        value => value.codigo !== 'CULTURA'
                    );
                }
            }
            this.tags = [...this.tags, ...this.culturas];
        }
    },
    computed: {
        ...mapGetters(['culturaFiltrada'])
    },
    created() {
        if (this.culturaFiltrada) {
            this.tags = [
                {
                    valor: this.culturaFiltrada,
                    codigo: 'CULTURA'
                }
            ];
        }
    },
    methods: {
        async pesquisar() {
            if (!this.pesquisa) return this.limpar();

            try {
                const { data } = await MonitoramentoAgricolaService.pesquisar(
                    this.pesquisa
                );
                this.resultadosPesquisa = data;
                if (data.length !== 0) {
                    this.mostrarResultado = true;
                } else {
                    this.mostrarResultado = false;
                }

                if (!data.length) {
                    this.exibirNotify(
                        'warning',
                        this.$t('mensagens.blocoFiltros.erros.pesquisar')
                    );
                }
            } catch (error) {
                this.exibirNotify(
                    'error',
                    this.$t('mensagens.blocoFiltros.erros.filtrar')
                );
            }
        },

        aplicar() {
            let idTerritorios = [];
            for (const resultado of this.resultadosSelecionados) {
                if (resultado.filtro && resultado.filtro.idTerritorio) {
                    idTerritorios = this.resultadosSelecionados
                        .map(t => t.filtro.idTerritorio)
                        .filter(t => t);
                    break;
                }
            }
            let idRepresentantes = [];
            for (const resultado of this.resultadosSelecionados) {
                if (resultado.filtro && resultado.filtro.idRepresentante) {
                    idRepresentantes = this.resultadosSelecionados
                        .map(r => r.filtro.idRepresentante)
                        .filter(r => r);
                    break;
                }
            }

            let filtros;
            if (this.culturas.length === 0) {
                filtros = {
                    idCulturas: [],
                    possuiAlerta:
                        this.possuiAlertas !== ''
                            ? this.possuiAlertas === 'POSSUI'
                            : null,
                    idSafras: this.safrasSelecionadas.map(({ id }) => id),
                    idTerritorios: idTerritorios,
                    idRepresentantes: idRepresentantes
                };
            } else {
                filtros = {
                    possuiAlerta:
                        this.possuiAlertas !== ''
                            ? this.possuiAlertas === 'POSSUI'
                            : null,
                    idSafras: this.safrasSelecionadas.map(({ id }) => id),
                    idTerritorios: idTerritorios,
                    idRepresentantes: idRepresentantes
                };
            }
            this.tags = [
                ...this.safrasSelecionadas,
                ...this.resultadosSelecionados
            ];
            if (this.culturas.length > 0) {
                this.tags.push({
                    valor: this.cultura,
                    codigo: 'CULTURA'
                });
            }

            if (this.possuiAlertas !== '') {
                this.tags.push({
                    valor:
                        this.possuiAlertas === 'POSSUI'
                            ? this.$t('mensagens.blocoAlerta.possuiAlertas')
                            : this.$t('mensagens.blocoAlerta.naoPossuiAlertas'),
                    codigo: 'POSSUI_ALERTAS'
                });
            }
            if (this.estadoSelecionado.id && this.municipioSelecionado.id) {
                const estadoMunicipio = {
                    id: this.estadoSelecionado.id,
                    nome: `${this.municipioSelecionado.nome}/${this.estadoSelecionado.sigla}`,
                    codigo: 'ESTADO_MUNICIPIO'
                };

                this.tags.push(estadoMunicipio);
                filtros.idEstado = this.estadoSelecionado.id;
                filtros.idMunicipio = this.municipioSelecionado.id;
            } else {
                filtros.idEstado = '';
                filtros.idMunicipio = '';
            }

            if (this.culturas.length > 0) {
                this.$emit('atualizar-filtro-avancado', filtros, this.cultura);
            } else {
                this.$emit('atualizar-filtro-avancado', filtros);
            }
        },

        abrirCollapse(ref) {
            if (ref) {
                try {
                    const acao = this.acaoCollapse[ref];
                    if (!this[ref].length && typeof this[ref] !== 'string') {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        this.$t('mensagens.blocoFiltros.erros.buscarDados')
                    );
                }
            }
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);

            this.desmarcarFiltroPopover(filtro);
            if (filtro.codigo === 'CULTURA') {
                this.$emit('remover-cultura-selecionada');
                this.culturas = [];
            } else if (filtro.codigo === 'POSSUI_ALERTAS') {
                this.possuiAlertas = '';
            }
            this.aplicar();
        },

        desmarcarFiltroPopover(filtro) {
            this.safrasSelecionadas = this.safrasSelecionadas.filter(
                safra => safra !== filtro
            );
            this.resultadosSelecionados = this.resultadosSelecionados.filter(
                resultado => resultado !== filtro
            );

            if (filtro.codigo === 'ESTADO_MUNICIPIO') {
                this.estadoSelecionado = {};
                this.municipioSelecionado = {};
            }

            if (filtro.codigo === 'POSSUI_ALERTAS') {
                this.possuiAlertas = '';
            }
        },

        selecionarResultado(resultado) {
            this.adicionarResultado(resultado);

            this.aplicar();
        },

        adicionarResultado(resultado) {
            const filtro = {
                id:
                    resultado.filtro.idTerritorio ||
                    resultado.filtro.idRepresentante,
                filtro: resultado.filtro,
                nome: resultado.valor
            };

            filtro.codigo = `${filtro.id}_${filtro.nome}`;

            const adicionado = this.resultadosSelecionados.find(
                ({ codigo }) => codigo === filtro.codigo
            );

            if (!adicionado) {
                this.resultadosSelecionados.push(filtro);
            }
        },

        limpar() {
            this.mostrarResultado = false;
            this.resultadosPesquisa = [];
        },

        fecharLista() {
            // Necessário apenas por UX
            setTimeout(() => {
                this.mostrarResultado = false;
                this.resultadosPesquisa = [];
            }, 300);
        },

        async buscarSafras() {
            const { data } =
                await MonitoramentoAgricolaService.buscarSafraFiltroAvancado();
            this.safras = data;
        },

        async buscarEstados() {
            const { data } = await LocalidadeService.findEstados(false);
            this.estados = data;
        },

        async buscarMunicipios() {
            const { data } = await LocalidadeService.findMunicipios(
                this.estadoSelecionado.id,
                false
            );
            this.municipios = data;
        },

        exibirNotify(tipo, message) {
            this.$notify[tipo]({ message });
        }
    }
};
</script>

<style lang="scss" scoped>
.filtrar-monitoramento-agricola-container {
    display: flex;
    justify-content: space-between;
}

.filtrar-monitoramento-agricola-input-container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.filtrar-monitoramento-agricola__resultado {
    position: absolute;
    width: 100%;
}

.filtrar-monitoramento-agricola__resultado__nome {
    margin: 0px 10px;
}

.filtrar-monitoramento-agricola__input {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.filtrar-monitoramento-agricola__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.filtrar-monitoramento-agricola__categoria {
    font-weight: bold;
}

.filtrar-monitoramento-agricola-filtro-selecionado {
    margin-top: 15px;
    min-height: 42px;
}

.filtrar-monitoramento-agricola-filtro-selecionado__titulo {
    font-size: 18px;
    font-weight: 100;
}

.filtrar-monitoramento-agricola-filtro-selecionado__tag {
    margin: 0px 5px 10px 5px;
}

.filtrar-monitoramento-agricola-filtro-selecionado__nenhum {
    margin-left: 5px;
    font-weight: 100;
    font-style: italic;
    font-size: 14px;
}

.filtrar-monitoramento-agricola-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtrar-monitoramento-agricola-popover-header__text {
        color: var(--primary);
        font-weight: 600;
    }

    .filtrar-monitoramento-agricola-popover-header__link {
        color: #1989fa;
        text-decoration: underline;
        cursor: pointer;
    }
}

.filtrar-monitoramento-agricola-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox {
        margin-right: 12px !important;
        min-width: 200px;
    }

    .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
    }
}

.filtrar-monitoramento-agricola-popover-collapse__select {
    display: flex;
    justify-content: space-between;
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    .lyra-filtro:before {
        content: '';
        width: 15px !important;
        height: 12px !important;
        background-color: var(--primary) !important;
        margin-right: 6px;
    }
}

.el-collapse-item__possui-alertas {
    display: flex;
    gap: 24px;
}

.el-collapse-item__safras--loading {
    min-height: 100px;
}

.el-tag {
    border-radius: 20px !important;
}

.el-tag.el-tag--success {
    border-color: var(--secondary-two) !important;
    color: var(--white) !important;
    background: var(--secondary-two) !important;
}
</style>
